import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "index";

import { Grid } from "@mui/material";
import { GridSize } from "@mui/material/Grid";

import { ApplicationState } from "@store/index";
import { getProvider } from "fileParsing/definitions";
import { switchActive } from "@store/data/actions";
import useTranslations from "containers/hooks/useLanguageHook";

import SankeyChart from "../Visuals/Sankey/Sankey";
import { useContentSize } from "containers/hooks/useWindowSize";
import { setSidebarFilter } from "@store/filters/actions";
import { FilterType } from "@store/filters/types";
import { setCurrentVisualization } from "@store/options/actions";
import { VisTypes } from "@store/options/types";
import { VisPageWrapper } from "@pages/VisPageWrapper";
import MultipleViewTitleGrid from "../Components/MultipleViewTitleGrid";
import { calculateGridItemSize } from "@utils/format";
import UnknownProviderComponent from "../Components/UnknownProviderComponent";
const sankeyImage = new URL("../../../public/sankey.png", import.meta.url).href;

function SankeyPage() {
  const { width, height } = useContentSize();

  const dispatch = useAppDispatch();
  const { t } = useTranslations();
  const options = useAppSelector((state: ApplicationState) => state.options.options);
  const providerItems = useAppSelector((state: ApplicationState) => state.data.exports);

  useEffect(() => {
    dispatch(setSidebarFilter([FilterType.categories]));
    dispatch(setCurrentVisualization(VisTypes.Sankey));
  }, [dispatch]);

  const activeExports = providerItems.filter((d) => d.active);

  return (
    <VisPageWrapper
      title={t.Vis.Sankey}
      help={{
        title: t.LandingPage.SankeyTitle,
        description: t.LandingPage.SankeyText,
        image: sankeyImage, // to be changed,
      }}
    >
      {options.MultipleViews.value && activeExports.length > 1 ? (
        <Grid container spacing={1} sx={{ height: "100%", overflow: "hidden" }}>
          {activeExports.map((d, i, list) => (
            <Grid
              item
              xs={calculateGridItemSize(list.length) as GridSize}
              key={d.id}
              sx={{ height: "100%", overflow: "hidden" }}
            >
              <MultipleViewTitleGrid
                fileName={d.fileProperties.fileName}
                providerName={getProvider(d.providerId).name}
                handleHide={() => dispatch(switchActive(d.id))}
              />
              {d.providerId === "wrangled" ? (
                <UnknownProviderComponent />
              ) : (
                <SankeyChart
                  exportIds={[d.id]}
                  providerIds={[d.providerId]}
                  size={{
                    width,
                    height,
                  }}
                />
              )}
            </Grid>
          ))}
        </Grid>
      ) : (
        (() => {
          const validExports = activeExports.filter((exportItem) => exportItem.providerId !== "wrangled");
          if (validExports.length === 0) {
            return <UnknownProviderComponent />;
          }
          return (
            <SankeyChart
              exportIds={validExports.map((exportItem) => exportItem.id)}
              providerIds={validExports.map((exportItem) => exportItem.providerId)}
              size={{ width, height }}
            />
          );
        })()
      )}
    </VisPageWrapper>
  );
}

export { SankeyPage };
